import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-auto-small",
  "use": "icon-status-auto-small-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-status-auto-small\">\n    <path d=\"M3.95625 10.47L7.152 5.3568C7.54367 4.73013 8.45633 4.73013 8.848 5.3568L12.0438 10.47C12.46 11.136 11.9812 12 11.1958 12H4.80425C4.01881 12 3.53997 11.136 3.95625 10.47Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol